import { FC, useState } from "react";
import { changeFavoriteName, removeFavoriteName } from "../../apiClient";
import "../styles/FavoriteRenameModal.css";

interface FavoriteRenameModalProps {
    visible: boolean;
    folderId: string | null;
    currentName: string;
    onClose: () => void;
    onUpdate: (newName: string) => void;
}

const FavoriteRenameModal: FC<FavoriteRenameModalProps> = ({ visible, folderId, currentName, onClose, onUpdate }) => {
    const [newName, setNewName] = useState(currentName);

    const handleSave = async () => {
        if (folderId && newName.trim() !== "") {
            try {
                await changeFavoriteName(folderId, newName.trim());
                onUpdate(newName.trim());
                onClose();
            } catch (error) {
                console.error("Failed to rename favorite folder:", error);
            }
        }
    };

    const handleRemove = async () => {
        if (folderId) {
            try {
                const newname = await removeFavoriteName(folderId);
                onUpdate(newname.trim());
                onClose();
            } catch (error) {
                console.error("Failed to reset favorite folder name:", error);
            }
        }
    };

    if (!visible) {
        return null;
    }

    return (
        <div className="rename-modal-overlay" onClick={onClose}>
            <div className="rename-modal" onClick={e => e.stopPropagation()}>
                <div className="rename-modal-header">
                    <h3>Rename Favorite Folder</h3>
                    <button className="rename-modal-close" onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className="rename-modal-body">
                    <label>Name:</label>
                    <input
                        type="text"
                        className="rename-modal-input"
                        value={newName}
                        onChange={e => setNewName(e.target.value)}
                        placeholder="Enter new folder name"
                    />
                </div>
                <div className="rename-modal-footer">
                    <button className="rename-modal-cancel" onClick={onClose}>Cancel</button>
                    <button className="rename-modal-reset" onClick={handleRemove}>Reset</button>
                    <button className="rename-modal-save" onClick={handleSave} disabled={newName.trim() === "" || newName.trim() === currentName}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default FavoriteRenameModal;